/**
 * FirstRunHero - shown on the dashboard when the organization has no
 * project and no task yet. One single primary action (create the first
 * project) instead of four zero-value stat cards.
 */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FolderKanban, ArrowRight } from 'lucide-react';

export default function FirstRunHero() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center px-6 py-20 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 dark:bg-primary-900/30 dark:text-primary-300">
        <FolderKanban className="h-8 w-8" />
      </div>
      <h2 className="mt-6 text-2xl font-bold text-neutral-900 dark:text-white">
        {t('dashboard.firstRunTitle')}
      </h2>
      <p className="mt-2 max-w-md text-neutral-600 dark:text-neutral-400">
        {t('dashboard.firstRunSubtitle')}
      </p>
      <Link
        to="/projects/new"
        className="mt-8 inline-flex items-center gap-2 rounded-xl bg-primary-600 px-6 py-3 text-base font-medium text-white shadow-sm transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-900"
      >
        {t('dashboard.firstRunCta')}
        <ArrowRight className="h-4 w-4" />
      </Link>
      <p className="mt-4 text-sm text-neutral-500 dark:text-neutral-500">
        {t('dashboard.firstRunHint')}
      </p>
    </div>
  );
}
